// railsの画面の一部をvuetifyで拡張するためのpack
import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import ja from 'vuetify/src/locale/ja'
import axios from 'axios'
import store from '@/store'
import RecruitsIndex from '@/pages/recruits/Index.vue'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.blue.darken4,
        accent: colors.orange.darken4,
        error: colors.red.base,
        secondary: colors.blueGrey.base
      }
    }
  }
})

setTimeout(() => {
  const settingsElement = document.querySelector('meta[name=settings]') as any
  const settings = JSON.parse(settingsElement.content)
  store.dispatch('setSettings', settings)
  if (document.getElementsByClassName('trigger-entry').length) {
    for(let i = document.getElementsByClassName('trigger-entry').length - 1; 0 <= i; i--) {
      new Vue({
        el: document.getElementsByClassName('trigger-entry')[i],
        render: h => h(RecruitsIndex),
        vuetify,
        store
      })
    }
  }
  // setTimeout(() => {
  //   document.getElementById('sign_up').classList.add('displayed')
  // })
}, 1000)

axios.interceptors.request.use(request => {
  const tokenElement = document.querySelector('meta[name=csrf-token]') as any
  request.headers.contentType = 'application/json; charset=utf8'
  request.headers.dataType = 'json'
  request.headers['X-CSRF-TOKEN'] = tokenElement ? tokenElement.content : null
  return request
})
